import React, { useState } from 'react';
import { API_URL } from '../../../Constant';
function AppointmentBooking() {
  const [appointmentTime, setAppointmentTime] = useState('');
  const [message, setMessage] = useState('');
  const [meetingLink, setMeetingLink] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const time = new Date(appointmentTime);
    const requestBody = { AppointmentTime: time };

    try {
      const response = await fetch(`${API_URL}api/appointments/book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });
      const data = await response.json();
      if (response.ok) {
        setMessage("Appointment booked successfully!");
        setMeetingLink(data.appointment.ZoomMeetingLink);
      } else {
        setMessage(data.message || "Failed to book appointment.");
      }
    } catch (error) {
      console.error(error);
      setMessage("An error occurred while booking the appointment.");
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Book Appointment</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '10px' }}>
          <label>Appointment Time: </label>
          <input
            type="datetime-local"
            value={appointmentTime}
            onChange={(e) => setAppointmentTime(e.target.value)}
          />
        </div>
        <button type="submit">Book Appointment</button>
      </form>
      {message && <p>{message}</p>}
      {meetingLink && (
        <p>
          Zoom Meeting Link: <a href={meetingLink} target="_blank" rel="noreferrer">{meetingLink}</a>
        </p>
      )}
    </div>
  );
}

export default AppointmentBooking;
